import { Box, Typography, Button, Stack } from "@mui/material";

const LuxuryHero = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        position: "relative",
        color: "#fff",

       
      }}
    >
      <Box maxWidth="900px" px={2}>
        
        {/* 🔥 MAIN HEADING */}
        <Typography
        variant="h5"
          sx={{
            
            fontWeight: 400,
            lineHeight: 1.2,
            letterSpacing: "2px",
            mb: 3,
            color:"white",
            fontSize: {
              xs: "2.8rem",
              md: "5rem",
            },
          }}
        >
          Clarity.
          <br />
          Confidence.
          <br />
          Conversion.
        </Typography>

        {/* 🔥 SUB TEXT */}
        <Typography
          sx={{
            fontSize: { xs: "0.95rem", md: "1.2rem" },
            opacity: 0.85,
            mb: 5,
            letterSpacing: "1px",
            color: "white",
          }}
        >
          Elevate Your Sales Mastery to the Highest Level
        </Typography>

        {/* 🔥 BUTTONS */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={3}
          justifyContent="center"
        >
          {/* GOLD BUTTON */}
          <Button
            sx={{
              px: 5,
              py: 1.5,
              borderRadius: "6px",
              background: "#0f63a5",
              color: "#fff",
              fontWeight: 600,
              textTransform: "none",
              letterSpacing: "1px",
              backdropFilter: "blur(4px)",

              "&:hover": {
                background: "#000",
                color:'white'
              },
            }}
          >
            Schedule Consultation
          </Button>

          {/* TRANSPARENT BUTTON */}
          <Button
            variant="outlined"
            sx={{
              px: 5,
              py: 1.5,
              borderRadius: "6px",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.5)",
              background: "rgba(255,255,255,0.05)", // 🔥 transparency
              backdropFilter: "blur(6px)",

            //   fontWeight: 500,
              textTransform: "none",
              letterSpacing: "1px",

              "&:hover": {
                background: "rgba(255,255,255,0.15)",
                borderColor: "#fff",
                color:'white'
              },
            }}
          >
            Explore Our Approach
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default LuxuryHero;